let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6bEGe")).then(() => parcelRequire('dK43S'));